import React, { useEffect, useState } from "react";
import { Download, Contact } from "lucide-react";
import api, { API } from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";

export default function Leads() {
  const [leads, setLeads] = useState([]);
  useEffect(() => { api.get("/leads").then((r) => setLeads(r.data)); }, []);

  const exportCsv = () => {
    const token = localStorage.getItem("iw_token");
    fetch(`${API}/leads/export`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((b) => { const u = URL.createObjectURL(b); const a = document.createElement("a"); a.href = u; a.download = "iwurks360_leads.csv"; a.click(); URL.revokeObjectURL(u); });
  };

  return (
    <DashboardLayout title="Leads"
      actions={leads.length > 0 && <button onClick={exportCsv} className="btn-gold px-4 py-2.5 rounded-full text-sm flex items-center gap-2" data-testid="export-csv-btn"><Download size={16} /> Export CSV</button>}>
      {leads.length === 0 ? (
        <div className="iw-card p-12 text-center">
          <Contact className="text-[#D4AF37] mx-auto mb-3" size={32} />
          <h3 className="font-display text-2xl font-bold">No leads yet</h3>
          <p className="text-[#8B9BB4] mt-2">When visitors exchange details on your cards, they'll appear here.</p>
        </div>
      ) : (
        <div className="iw-card overflow-hidden">
          <table className="w-full text-sm" data-testid="leads-table">
            <thead className="bg-[#142B5A] text-[#8B9BB4]">
              <tr>
                <th className="text-left px-5 py-3 font-semibold">Name</th>
                <th className="text-left px-5 py-3 font-semibold">Email</th>
                <th className="text-left px-5 py-3 font-semibold">Phone</th>
                <th className="text-left px-5 py-3 font-semibold hidden md:table-cell">Message</th>
                <th className="text-left px-5 py-3 font-semibold hidden lg:table-cell">Card</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((l) => (
                <tr key={l.id} className="border-t border-[#ffffff1a]">
                  <td className="px-5 py-3 text-[#F6F1E4] font-medium">{l.name}</td>
                  <td className="px-5 py-3 text-[#8B9BB4]">{l.email || "—"}</td>
                  <td className="px-5 py-3 text-[#8B9BB4]">{l.phone || "—"}</td>
                  <td className="px-5 py-3 text-[#8B9BB4] hidden md:table-cell">{l.message || "—"}</td>
                  <td className="px-5 py-3 text-[#8B9BB4] hidden lg:table-cell">{l.card_slug}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DashboardLayout>
  );
}
